import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface IActiveSectionContext {
  activeSectionId: string;
  setActiveSectionId: (id: string) => void;
}

const ActiveSectionContext = createContext<IActiveSectionContext>({
  activeSectionId: '',
  setActiveSectionId: () => {},
});

interface ActiveSectionContextProviderProps {
  children: React.ReactNode;
  value?: { activeSectionId?: string };
}

export const ActiveSectionContextProvider = ({
  children,
  value,
}: ActiveSectionContextProviderProps) => {
  const [activeSectionId, setActiveSectionId] = useState<string>(value?.activeSectionId || '');

  return (
    <ActiveSectionContext.Provider value={{ activeSectionId, setActiveSectionId }}>
      {children}
    </ActiveSectionContext.Provider>
  );
};

export const useActiveSectionContext = () => {
  const context = useContext(ActiveSectionContext);

  if (context === undefined) {
    throw new Error('useActiveSectionContext must be used within a ActiveSectionContextProvider');
  }

  return context;
};
